import { TimerTopBar } from '../shared/TimerTopBar'

interface HeaderProps {
	onFinish: () => void
}

export const Header = ({ onFinish }: HeaderProps) => {
	return (
		<TimerTopBar
			center={
				<button
					type='button'
					onClick={onFinish}
					className='min-h-[38px] whitespace-nowrap rounded-[999px] border-2 border-[#5E6BFF] px-4 py-1.5 text-[13px] font-semibold text-[#5E6BFF] transition-colors duration-150 ease-out hover:bg-[#F4F5FF] active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black'>
					Закончить тренировку
				</button>
			}
		/>
	)
}
